import React, { Component } from 'react';
import LinkTab from '../../../../common/tab/TabNav.js';
import MainTable from '../../../../common/table/MainTable';
import { tabs } from '../DividendUtil.js';
import * as columns from './DividendColumns';
import NewDividend from './NewDividend';
import * as util from '../../../../../utils/EnumMapping';

class Dividend extends Component {


    enrich = (data) => {
        data.map((item) => {
            item.rowType = "DIVIDEND";
            item.paymentMethodLabel = util.getLabel(util.outPaymentMethods, item.paymentMethod);
            item.stateLabel = util.getLabel(util.states, item.state);
            return item;
        })
        return data;
    }

    render() {
        return (
            <>
                <LinkTab tabs={tabs} index={1} />
                <MainTable
                    divClassName="dividend"
                    tableName="Osztalékok"
                    newObjectLabel="Új osztalék hozzáadása"
                    path='/api/dividends'
                    enrich={this.enrich}
                    columns={(props) => columns.columns(props)}
                    dialogContent={(refresh, close) => <NewDividend refresh={refresh} close={close} />} />
            </>
        );
    }
}

export default Dividend;

